import { OtpErrorTypes } from '../typings';
export const otpErrorCallbackParamsKey = 'otpErrorCallbackParams';
export const OtpErrorCodes = {
    [OtpErrorTypes.INVALID_SCOPE]: 'invalid_scope',
    [OtpErrorTypes.USER_DECLINED]: 'user_declined',
    [OtpErrorTypes.ACCESS_DENIED]: 'access_denied',
    [OtpErrorTypes.SERVER_ERROR]: 'server_error',
    [OtpErrorTypes.UNHANDLED_ERROR]: 'Unhandled error:'
};
